export default function authHeader() {
    const user = JSON.parse(localStorage.getItem('user'));
  
    if (user && user.tokens && user.tokens.access) {
      // for Node.js Express back-end
      return { 'Authorization': `Bearer ${user.tokens.access.token}` };
    } else {
      return {};
    }
  }

  